import { useCallback } from 'react'
import usePresenceChannel, {
  PresencePayload,
  PresenceViewer as Viewer,
} from 'app/frontend/base/hooks/usePresenceChannel'
import RaidPlan from 'app/frontend/types/custom/RaidPlan'

type Options = {
  eventId?: number
  onEventUpdated?: (event: wowaudit.Event) => void
  onLinkedRaidPlanUpdated?: (raidPlan: RaidPlan) => void
}

type EventChannelPayload = PresencePayload & {
  event?: wowaudit.Event
  raid_plan?: RaidPlan
}

const useEventChannel = ({
  eventId,
  onEventUpdated,
  onLinkedRaidPlanUpdated,
}: Options) => {
  const handlePayload = useCallback(
    (payload: EventChannelPayload) => {
      if (payload.type === 'event_updated' && payload.event) {
        onEventUpdated?.(payload.event)
      }
      if (payload.type === 'linked_raid_plan_updated' && payload.raid_plan) {
        onLinkedRaidPlanUpdated?.(payload.raid_plan)
      }
    },
    [onEventUpdated, onLinkedRaidPlanUpdated],
  )

  const { viewers, requiresReload } = usePresenceChannel<EventChannelPayload>({
    channelName: 'EventChannel',
    channelId: eventId,
    channelIdParam: 'event_id',
    onPayload: handlePayload,
  })

  return {
    viewers,
    requiresReload,
  }
}

export type { Viewer }
export default useEventChannel
